import { controls } from "../controls";

const slbchome = {
  label: "Home",
  pageLabel: "Dashboard 2",
  starting: true,
  url: "home",
  pageType: "history",
  dashboard: [
    ...controls.displayText({ width: "col-sm-12", label: " ", tab: "filter" }),
    {
      widths: "col-sm-4",
      tab: "create",
      theme: "orotheme",
      title: "Getting Started icon-selfWhatsApp",
      footer: "one time activity",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list1",
          values: [
            { main: { desc: "Bank Details", url: "bank", value: "icon-tick", color: "#8af07f" } },
            { main: { desc: "Branches", url: "branches", value: "icon-tick", color: "#8af07f" } },
            { main: { desc: "Zones", url: "rbi_mis_nos", value: "icon-tick", color: "#8af07f" } },
            { main: { desc: "GL", url: "gls", value: "icon-tick", color: "#8af07f" } },
            { main: { desc: "GL Map", url: "groups", value: "icon-cross", color: "#ff4646" } },
            { main: { desc: "ATM", value: "13", color: "#8af07f" } },
          ]
        }),
      ]
    },
    {
      widths: "col-sm-4",
      tab: "create",
      title: "Quarterly Activities - CBS icon-selfWhatsApp",
      footer: "To be generated from Finacle",
      // style:{border:"none"},
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Trial Balance", url: "upload_trial_balances", value: "icon-tick", color: "green" } },
            { main: { desc: "Receipt Payment", url: "gls", value: "icon-tick", color: "green" } },
            { main: { desc: "Overdue GL", url: "gls", value: "icon-add", color: "orange" } },
            { main: { desc: "Outstanding Accounts", url: "gls", value: "icon-tick", color: "green" } },
            { main: { desc: "Disbursed Accounts", url: "gls", value: "icon-tick", color: "green" } },
            { main: { desc: "Overdue Accounts", url: "gls", value: "icon-add", color: "orange" } },
            { main: { desc: "Digital Transactions", url: "gls", value: "icon-tick", color: "green" } },
            { main: { desc: "Card Disbursement", url: "gls", value: "icon-tick", color: "green" } },
          ]
        }),
      ]
    },
    {
      widths: "col-sm-4",
      tab: "create",
      title: "Quarterly Activities - Agriculture icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "Agriculture Loan Data from PACS",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Disbursed Caste & Women Loans", url: "gls", value: "icon-tick", color: "green" } },
            { main: { desc: "Outstanding Caste & Women Loans", url: "gls", value: "icon-tick", color: "green" } },
            { main: { desc: "Overdue Caste & Women Loans", url: "gls", value: "icon-add", color: "orange" } },
            { main: { desc: "Purposewise Loans", url: "gls", value: "icon-tick", color: "green" } },
            { main: { desc: "NPA GL", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "NPA Accounts", url: "gls", value: "icon-cross", color: "red" } },
          ]
        }),
      ]
    },
    {
      widths: "col-sm-4",
      tab: "create",
      theme: "targettheme",
      selfWhatsApp: "sendsummary",
      title: "Compliance icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "As of today",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "September 2021", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "June 2021", url: "gls", value: "icon-tick", color: "green" } },
          ]
        }),
      ]
    },

  ]
};

export default slbchome;